/**
 * @file 计算组件类型
 */

import { kebabCase } from 'lodash-es';
import { COMPONENT_PREFIX } from '../constants';

export function useComponentType(options: IUsePropsOptions) {
  const { config } = options;
  const { act: buttonComponentHocType = '' } = config;
  let { type: componentType } = config;

  componentType = `${COMPONENT_PREFIX}-${kebabCase(componentType)}`;

  // 按钮类型的高阶组件
  if (componentType === `${COMPONENT_PREFIX}-action-button`) {
    componentType = `${COMPONENT_PREFIX}-button`;
    const buttonHocType = kebabCase(buttonComponentHocType);

    // 链接类型
    if (buttonHocType === 'url') {
      componentType = `${COMPONENT_PREFIX}-link`;
      // 其他按钮
    } else if (buttonHocType && !buttonHocType.endsWith('pop')) {
      componentType = `${COMPONENT_PREFIX}-${buttonHocType}-button`;
    }
  }

  return {
    componentType,
  };
}

interface IUsePropsOptions {
  config: any;
}
